import $ from 'jquery';
import * as CONST from '../../utils/constants';

const Tabs = CONST.globalProject.SelectedTabs;

class TimeFrames { 
    constructor() {
    }

    init() {
        this.nav = $('.tabbed-navigation');
        if (this.nav.length <= 0) { return; } 
        this.tabs = document.querySelector('.tabbed-navigation__tabs');
        this.trigger = document.querySelector('.tabbed-navigation__trigger');
        this.dropdown = document.querySelector('.tabbed-navigation__dropdown');
        this.options = document.querySelectorAll('.tabbed-navigation__option');
        this.optionsMobile = document.querySelectorAll('.filters_item');
        this.agendabtns = document.querySelector('.meetings-buttons');
        this.quickbtn = document.querySelector('.meetings-quick');
        this.fullbtn = document.querySelector('.meetings-full');
        this.frames = document.querySelectorAll('.time-frames');
        this.triggerSpan = this.trigger.querySelector('span');
        this.filtersOverlay = document.querySelector('.filters__overlay');
        this.closebtn = document.querySelector('.filters__close');
        this.speaker = document.querySelectorAll('.time-frame_speaker');
        console.log(this.speaker);
        this.bindScrollEvents();
        this.bindDropdownEvents();
        this.bindOptionClickEvent();
        this.bindModalEvents();
        this.enableAgendaButtons();


         window.addEventListener('hashchange', () => {
            const tabName = window.location.hash.substring(1);
            this.activateTab(tabName); });
        if (window.location.hash) {
            const tabName = window.location.hash.substring(1);
            this.activateTab(tabName);
        } else if (this.options && this.options.length > 0) {
                this.options[0].click(); // Default to first tab
        }

        if (Tabs.length === 1) {
            this.activateTab(Tabs[0]);
        }
    }

    bindScrollEvents() {
        const tabsOffset = this.tabs.getBoundingClientRect().top + window.scrollY;
        window.addEventListener('scroll', () => {
            if (window.scrollY >= tabsOffset - 16) {
                this.tabs.classList.add('is-fixed');
            } else {
                this.tabs.classList.remove('is-fixed');
            }
        });
    }

    bindModalEvents() {
        if (!this.speaker) {
            return;
        }

        let modal = $('.time-frame_speaker_modal').html();
        if (modal != null) {
            $('.time-frame_speaker').modaal({
                content_source: '#time-frame_speaker_modal',
                overlay_opacity: 0.6,
                width: 1250,
                hide_close: true,
                custom_class: 'time-frame_speaker_modal_container',
                before_open: (e) => {
                    const el = e.target.closest('.time-frame_speaker');
                    if (!el) return;

                    const data = {
                        image: el.dataset.image || '',
                        name: el.dataset.name || '',
                        title: el.dataset.title || '',
                        bio: el.dataset.bio || ''
                    };

                    window.Launchpad.Speaker = data.image;

                    // Target both the hidden original template and Modaal's generated wrapper
                    const $containers = $('#time-frame_speaker_modal, .modaal-wrapper .time-frame_speaker_modal');

                    // Update images and text synchronously before layout render
                    $containers.find('.time-frame_speaker_modal_image').attr({ src: data.image, alt: data.name });
                    $containers.find('.time-frame_speaker_modal_profile_name').text(data.name);
                    $containers.find('.time-frame_speaker_modal_profile_title').text(data.title);
                    $containers.find('.time-frame_speaker_modal_bio').html(data.bio);
                },
                after_open: (e) => {
                    const data = {
                        image: window.Launchpad.Speaker || ''
                    };

                    const $containers = $('#time-frame_speaker_modal, .modaal-wrapper .time-frame_speaker_modal');
                    $containers.find('.time-frame_speaker_modal_image').attr({ src: data.image, alt: data.name });
                }
            });
            }
  
    
            $('.time-frame_speaker_modal_close').on('click', () => {
                $('.time-frame_speaker').modaal('close');
            });

        $(document).on('click', (e) => {
            if ($(e.target).hasClass('modaal-outer-wrapper')) {
                $('.time-frame_speaker').modaal('close');
            }
        });
    }

    bindDropdownEvents() {
        this.trigger.addEventListener('click', (event) => {
            event.stopPropagation();
            //this.dropdown.classList.toggle('is-active');
            $(this.filtersOverlay).toggleClass('closed');
        });

        this.closebtn.addEventListener('click', (event) => {
            $(this.filtersOverlay).addClass('closed');
        });

        document.addEventListener('click', (event) => {
            if (!this.tabs.contains(event.target)) {
                this.dropdown.classList.remove('is-active');
            }
        });
    }

    bindOptionClickEvent() {
        this.options.forEach(option => {
            option.addEventListener('click', () => {
                const tabName = option.textContent.trim().toLowerCase().replace(/\s+/g, '-');
                this.activateTab(tabName, true);
            });
        });

        this.optionsMobile.forEach(option => {
            option.addEventListener('click', () => {
                const tabName = option.textContent.trim().toLowerCase().replace(/\s+/g, '-');
                this.activateTab(tabName, true);
                $(this.filtersOverlay).addClass('closed');
            });
        });

        this.quickbtn.addEventListener('click', (event) => {
            $(this.quickbtn).addClass('active');
            $(this.fullbtn).removeClass('active');
            this.frames.forEach((n) => { n.classList.add('collapsed'); });
        });
        this.fullbtn.addEventListener('click', (event) => {
            $(this.fullbtn).addClass('active');
            $(this.quickbtn).removeClass('active');
            this.frames.forEach((n) => { n.classList.remove('collapsed'); });
        });
    }

    activateTab(tabName, updateHash = false) {
        const matchingOption = Array.from(this.options).find(opt => opt.textContent.trim().toLowerCase().replace(/\s+/g, '-') === tabName);

        if (matchingOption) {
            this.triggerSpan.textContent = matchingOption.textContent;

            this.options.forEach(opt => opt.classList.remove('is-active'));
            matchingOption.classList.add('is-active');

            this.dropdown.classList.remove('is-active');

            // Update the sections visibility
            document.querySelectorAll('.tabbed-navigation__section').forEach(section => {
                section.classList.remove('is-active');
            });

            const activeSection = document.getElementById(tabName);
            if (activeSection) {
                activeSection.classList.add('is-active');
            }

            if (updateHash) {
                window.history.pushState(null, '', `#${tabName}`);
            }
        }
    }

    enableAgendaButtons() {
        const contents = document.querySelectorAll('.time-frame_content');
        let hasContent = false;
        if (contents.length > 0) {
            for (const [index, x] of contents.entries()) {
                if (x.innerText.trim().length > 0) {
                    hasContent = true;
                    break;
                }
            }
        } 
        if (!hasContent) {
            this.agendabtns.classList.add('hidden');
        }
    }
}

export default TimeFrames;

$(() => {
    const timeFrames = new TimeFrames();
    setTimeout(() => {    timeFrames.init(); }, 500);
});